import { ViewModelDadosInstitutos } from "./ViewModelDadosInstitutos.model";
import { ViewModelDadosModulos } from "./ViewModelDadosModulos.model";
import { WebInstitutos } from "./WebInstitutos.model";
import { WebModulos } from "./WebModulos.model";
import { Plano } from "./plano.model";

export class WebModulosTextos {
    idSeq: number;
    plano: Plano;
    institutos: ViewModelDadosInstitutos;
    modulos: ViewModelDadosModulos;
    nmTexto: string;
    icTravaUltimoDia: string;
}